import { Link } from "react-router-dom";
import Ico from "../components/Icons";
import useReveal from "../hooks/useReveal";

const REALS = [
  { grad:"linear-gradient(135deg,#0a2540,#1a6fd4)", ico:"globe",    tag:"Site E-commerce",   title:"Boutique Mode Dakar",    sub:"Refonte complète de la boutique en ligne, intégration d'un logiciel de caisse et optimisation SEO pour capter la recherche locale.", result:"+65% de trafic en 3 mois" },
  { grad:"linear-gradient(135deg,#071428,#0d4a8c)", ico:"cpu",      tag:"App sur-mesure",    title:"Restaurant La Terrasse", sub:"Application de commande en salle, gestion des tables en temps réel et caisse tactile reliée à la cuisine.", result:"−30% de temps de service" },
  { grad:"linear-gradient(135deg,#0d3d70,#00c8ff)", ico:"barChart", tag:"Marketing Digital", title:"Cabinet ADS Conseil",    sub:"Stratégie réseaux sociaux, campagnes Google Ads ciblées et tableau de bord de reporting mensuel pour suivre chaque euro investi.", result:"×2,4 leads qualifiés" },
  { grad:"linear-gradient(135deg,#0a2540,#00c8ff)", ico:"mapPin",   tag:"Google Business",   title:"Pharmacie du Plateau",   sub:"Optimisation complète de la fiche Google, gestion active des avis clients et amélioration du référencement local.", result:"Top 3 recherches locales" },
  { grad:"linear-gradient(135deg,#071428,#1a6fd4)", ico:"package",  tag:"Pack Business Pro", title:"Salon Beauté Éclat",     sub:"Site vitrine, fiche Google, branding et logiciel de réservation réunis dans une mise en place express.", result:"Mise en ligne en 4 jours" },
  { grad:"linear-gradient(135deg,#0d3d70,#1a6fd4)", ico:"zap",      tag:"Automatisation",    title:"Grossiste TechImport",   sub:"Automatisation des rapports de vente hebdomadaires et des relances clients, auparavant gérés manuellement.", result:"6h/semaine économisées" },
];

const STATS = [
  ["50+", "Projets livrés"],
  ["9", "Secteurs d'activité"],
  ["98%", "Clients satisfaits"],
  ["3 ans", "D'expérience terrain"],
];

export default function Realisations() {
  useReveal();

  return (
    <div className="pagewrap">
      <section className="sec" style={{ background: "var(--w)" }}>
        <div className="secinr">
          <div className="sechdr r">
            <div className="lbl"><span className="lblline" />Portfolio</div>
            <h2 className="sh2">Quelques <em>réalisations</em></h2>
            <p className="slead">Des projets concrets, menés avec des commerçants et entrepreneurs sénégalais, avec des résultats mesurables à la clé — pas juste de belles promesses.</p>
          </div>

          <div className="statstrip r" style={{ transitionDelay: ".05s" }}>
            {STATS.map(([v, l]) => (
              <div className="statstripc" key={l}>
                <div className="statstripv">{v}</div>
                <div className="statstripl">{l}</div>
              </div>
            ))}
          </div>

          <div className="realgrid">
            {REALS.map((r, i) => (
              <div className="realc r" key={r.title} style={{ transitionDelay: `${i * .08}s` }}>
                <div className="realthumb" style={{ background: r.grad }}>
                  <div className="realiwrap"><Ico name={r.ico} size={26} color="#fff" /></div>
                </div>
                <div className="realbody">
                  <div className="realtag">{r.tag}</div>
                  <div className="realtitle">{r.title}</div>
                  <p className="realsub">{r.sub}</p>
                  <div className="realresult"><Ico name="check" size={11} color="#16a34a" />{r.result}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="ctaband r" style={{ transitionDelay: ".2s" }}>
            <div>
              <h3>Votre projet pourrait être le prochain</h3>
              <p>Parlons de vos objectifs et voyons comment atteindre des résultats similaires pour votre activité.</p>
            </div>
            <Link className="ctabtn" to="/contact?sujet=projet">Démarrer mon projet <Ico name="arrowR" size={15} color="var(--blue)" /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}